/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Badge, Box, Button, Flex, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useToast } from '@chakra-ui/react';
import { faExternalLinkAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ListLoading from '../../../components/ListLoading';
import RichTextViewer from '../../../components/form/RichTextEditorField/viewer';
import NewNpModal from '../../NoteOfPresentation/components/NewNpModal';
import NoteOfPresentationPreviewModal from './NoteOfPresentationPreviewModal';
import useStore from '../../../store';
import c from '../../../constant';

const Q_GET_REQUESTS = gql`
	query getProposalNpsByProposalNumber($proposalNumber: Float!) {
		getProposalNpsByProposalNumber(proposalNumber: $proposalNumber)
	}
`;

function NoteOfPresentationLink({ proposalNumber, proposalDone }) {
	const toast = useToast();
	const history = useHistory();
	const { t } = useTranslation();
	const { currentUser: user } = useStore((state) => state?.currentUser);
	const [object, setObject] = useState(null);
	const [loadData, { loading, data }] = useLazyQuery(Q_GET_REQUESTS);
	const [openCreateNewNp, setOpenCreateNewNp] = useState(false);

	useEffect(() => proposalNumber && loadData({ variables: { proposalNumber } }), [proposalNumber]);

	return (
		<>
			<Flex direction={['column', 'row', 'row']} justifyContent="flex-start" alignItems={['flex-start', 'center', 'center']}>
				<Text fontWeight="bold" minW="165px" w="165px" noOfLines={2}>
					{t('np or rp')}
				</Text>
				<Box width={['100%', 'auto', 'auto']} ml={[0, 4, 4]} mt={[2, 0, 0]}>
					<ListLoading loading={loading} loadedList={data?.getProposalNpsByProposalNumber} animation={false} hideEmpty={true}>
						{({ loadedList }) => (
							<>
								{loadedList?.length > 0 && (
									<TableContainer mb="2">
										<Table size="sm" variant="simple">
											<Thead>
												<Tr>
													<Th pl={1} pr={1} pb={2} pt={2}>
														{t('Number')}
													</Th>
													<Th pl={1} pr={1} pb={2} pt={2}>
														{t('Subject')}
													</Th>
													<Th pl={1} pr={1} pb={2} pt={2} isNumeric minW="64px">
														{t('Step')}
													</Th>
												</Tr>
											</Thead>
											<Tbody>
												{loadedList?.map((item, index) => {
													return (
														<Tr key={index} _hover={{ bg: 'gray.100' }}>
															<Td cursor="pointer" pl={1} pr={1} pb={1} pt={1}>
																<Text
																	color="#3498DA"
																	fontWeight="bold"
																	onMouseDown={() => {
																		const viewerIds = item?.viewers?.map((viewer) => viewer?.userViewer?.id) || [];
																		const canView = viewerIds?.includes(user?.id) || user?.role === 'admin';
																		if (canView) {
																			history.push(`/note-of-presentation/detail?id=${item?.id}&type=${item?.type}`);
																		} else {
																			toast({
																				title: t('Only reviewers can see') + t(item?.type),
																				status: 'warning',
																				isClosable: true,
																				position: 'bottom',
																			});
																		}
																	}}
																>
																	{item?.number || 'N/A'}
																	<FontAwesomeIcon
																		icon={faExternalLinkAlt}
																		style={{ fontSize: 12, color: '#3498DA', marginLeft: 4 }}
																	/>
																</Text>
															</Td>
															<Td
																pl={1}
																pr={1}
																pb={1}
																pt={1}
																cursor="zoom-in"
																onMouseDown={(e) => {
																	e?.preventDefault();
																	const width = 1024;
																	const height = 720;
																	const x = (screen.width - width) / 2;
																	const y = (screen.height - height) / 2;
																	const windowFeatures = `width=${width},height=${height},left=${x},top=${y}`;
																	window?.open(
																		'/#/company-submission-proposal/np/popout?id=' +
																			item?.id +
																			'&from=Proposal&preview=true',
																		'_blank',
																		windowFeatures
																	);
																}}
															>
																<Box className="pnplg" display={['none', 'block', 'block']}>
																	<RichTextViewer value={item?.subject} makeup={true} />
																</Box>
																<Box className="pnplm" display={['block', 'none', 'none']}>
																	<RichTextViewer value={item?.subject} makeup={true} />
																</Box>
															</Td>
															<Td pl={1} pr={1} pb={1} pt={1} isNumeric>
																<Badge>{t(item?.step)}</Badge>
															</Td>
														</Tr>
													);
												})}
											</Tbody>
										</Table>
									</TableContainer>
								)}
								<Box w="100px" mt={[2, 0, 0]} hidden={proposalDone}>
									<Button
										onMouseDown={() => setOpenCreateNewNp(true)}
										width="100%"
										leftIcon={<FontAwesomeIcon icon={faPlus} style={{ fontSize: 16 }} />}
										colorScheme="gray"
										variant="solid"
										size="sm"
										borderRadius={c.borderRadius}
										border="1px solid #bdc3c7"
									>
										{t('Create')}
									</Button>
								</Box>
							</>
						)}
					</ListLoading>
				</Box>
			</Flex>
			{openCreateNewNp && (
				<NewNpModal
					onClose={() => setOpenCreateNewNp(false)}
					onComplete={(result) => history.push('/note-of-presentation/detail?id=' + result?.id + '&type=' + result?.type)}
					proposalNumberLink={proposalNumber}
				/>
			)}
			{object && <NoteOfPresentationPreviewModal id={object?.id} title={object?.type} onClose={() => setObject(null)} />}
		</>
	);
}

export default NoteOfPresentationLink;
